module.exports = __webpack_public_path__ + "img/premio2.2ed1a575.png";